import { camelizeKeys } from 'humps';

import { NavigationHnCData } from 'types';

export const getNavigationData = async (): Promise<any> => {
  const response = await fetch('/api/navigation', {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('unexpected http error occured');
  }
  const json = await response.json();
  return camelizeKeys(json);
};

export const getNavigationHnCData = async (): Promise<NavigationHnCData> => {
  const response = await fetch('/api/navigation/topics');
  const data = await response.json();
  return data;
};
